import { ParentInfoErrors, ParentInfoConfig } from './../../../models/parent-guardian-details';
import { Component, OnInit, Input, forwardRef, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { slideInOut } from 'src/app/application/animations/slideInOut';
import { ParentInfo } from 'src/app/application/models/parent-guardian-details';
import { LookupData, Relationship, RelationshipType } from 'src/app/shared/models/lookup-data.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'online-app-parent-legalcustodian-info',
  templateUrl: './parent-legalcustodian-info.component.html',
  styleUrls: ['./parent-legalcustodian-info.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ParentLegalcustodianInfoComponent),
    multi: true
  }],
  animations: [slideInOut]
})
export class ParentLegalcustodianInfoComponent implements OnInit, OnChanges, ControlValueAccessor {

  @Input() config: ParentInfoConfig;
  @Input() errors: ParentInfoErrors;
  @Input() data: ParentInfo;

  // @Input() formGroup: FormGroup;

  parentInfoFormGroup: FormGroup;

  isParentTheCarer: boolean;
  isSingleParent: boolean = null;
  hasLegalCustody: boolean;
  isDeceased: boolean = false;
  selectedRelationship: LookupData;
  isSubmittedApplication: boolean = false;
  relationships: RelationshipType[] = [];

  private _value: ParentInfo = {
    Relationship: undefined,
    OtherRelationship: undefined,
    IsDeceased: undefined,
    GivenName: undefined,
    FamilyName: undefined,
    OnlyHasOneName: undefined,
    HasLegalCustody: undefined
  };

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) {
    this.selectedRelationship = this.getDefaultRelationship();
  }

  ngOnInit() {
    this.isSingleParent = false;

    this.parentInfoFormGroup = this.formBuilder.group({
      hasLegalCustody: '',
      isDeceased: '',
      GivenName: ['test', Validators.required],
      FamilyName: ['test1', Validators.required],
    });

    this.isParentTheCarer = this.config.isParentTheCarer;
    this.relationships = this.activatedRoute.snapshot.data['relationshipTypes'];

    if (this.config.isParent) {
      this.relationships = this.relationships.filter(r => r.IsParent);
    } else {
      //this.relationships = this.relationships.filter(r => !r.IsParent);
      this.relationships = this.relationships.filter(rel => rel.IsParent || rel.IsDirectRelative || rel.IsParentNomination || rel.IsHomestay || rel.Code == 'AGENT')
    }

    //trikc to wait this child-component fully loaded
    window.setTimeout(() => {
      //console.log('window.setTimeout');
      //console.log(this.value.Relationship);
      if (this.value.Relationship) {
        this.initialLoadRelationShipUpdate(this.value.Relationship);
        //console.log("set relationship!!" + this.value.Relationship)
      }
    });


  }




  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.value = changes.data.currentValue;
    }
    // const { Relationship } = changes.data.currentValue;
    // this.relationshipUpdate(Relationship);   
  }


  private _onChange = (_: any) => { };
  private _onTouched = (_: any) => { };

  set value(value: ParentInfo) {
    this._value = value;
    this._onChange(this._value);
  }
  get value() {
    return this._value;
  }
  writeValue(value: ParentInfo): void {
    if (value && value !== null) {
      this._value = value;
    }
  }
  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: (_: any) => void): void {
    this._onTouched = fn;
  }
  private _updateValue(value: any, field: string) {
    const newValue = this._value;
    newValue[field] = value;
    this.value = newValue;
  }

  otherRelationshipUpdate(event: any) {
    this._updateValue(event.target.value, 'OtherRelationship');
    this.errors.OtherRelationship = '';
  }


  //as pre-reg page stores relationship description, we need to convert to code here
  //but if re-load existing P/LC, then code will do
  initialLoadRelationShipUpdate(codeOrDesc: string) {
    var foundRelationShip = this.relationships.find(relation => relation.Description === codeOrDesc);
    if (!foundRelationShip) {
      foundRelationShip = this.relationships.find(relation => relation.Code === codeOrDesc);
    }
    this.selectedRelationship = foundRelationShip ?
      { Code: foundRelationShip.Code, Description: foundRelationShip.Description }
      : this.getDefaultRelationship();
    this._updateValue(this.selectedRelationship.Code, 'Relationship');  //always update with Code
  }


  relationshipUpdate(code: any) {
    const selectedRelationShip = this.relationships.find(relation => relation.Code === code);
    this.selectedRelationship = selectedRelationShip ?
      { Code: selectedRelationShip.Code, Description: selectedRelationShip.Description }
      : this.getDefaultRelationship();

    this._updateValue(code, 'Relationship');
    this.errors.Relationship = '';
  }

  givenNameUpdate(event: any) {
    this._updateValue(event.target.value, 'GivenName');
    this.errors.GivenName = '';
    this.value.GivenName = this.titleCaseWord(this.value.GivenName);
  }

  familyNameUpdate(event: any) {
    this._updateValue(event.target.value, 'FamilyName');
    this.errors.FamilyName = '';
    this.value.FamilyName = this.value.FamilyName.toUpperCase();
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  isOnlyHasOneNameClicked(event) {
    if (this.config.isSubmittedApplication) {
      return;
    }

    this.value.OnlyHasOneName = event.checked;
    const onlyHasOneNameNewValue = this.value.OnlyHasOneName;
    this._updateValue(onlyHasOneNameNewValue, 'OnlyHasOneName');
    if (this.value.OnlyHasOneName) {
      this.value.FamilyName = '';
    }
    //this.errors.OnlyHasOneName = '';
  }

  isDeceasedClicked(event) {
    if (this.config.isSubmittedApplication) {
      return;
    }

    this.value.IsDeceased = event.checked;
    const isDeceasedNewValue = this.value.IsDeceased;
    this._updateValue(isDeceasedNewValue, 'IsDeceased');
    this.isDeceased = isDeceasedNewValue
    this.errors.IsDeceased = '';
  }

  updateLegalCustody(hasLegalCustody: boolean) {
    this.hasLegalCustody = hasLegalCustody;
    this._updateValue(hasLegalCustody, 'HasLegalCustody')
    this.errors.HasLegalCustody = '';

    this.parentInfoFormGroup.patchValue({
      hasLegalCustody
    });
    this.parentInfoFormGroup.updateValueAndValidity();
  }


  getDefaultRelationship(): LookupData {
    return {
      Code: '',
      Description: 'Please select'
    };
  }

  /* For accessibility, keyboard only design, use tab to show borders but showing no border by clicking on mouse */
  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }

  //accessibility -- link error msg to form field
  errorDoubleErrorAccessibility(): string {
    if (this.errors && this.errors.GivenName) {
      return "errorGivenName";
    } else if (this.parentInfoFormGroup.get('GivenName').errors &&
      this.parentInfoFormGroup.get('GivenName').errors.required) {
      return "requiredGivenName";
    } else {
      return "";
    }
  }
}
